import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <main className="min-h-screen relative pt-24 pb-24">
      {/* Ambient background glow */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px] -z-10 pointer-events-none"></div>
      
      <section className="max-w-4xl mx-auto px-margin-mobile md:px-margin-desktop">
        
        {/* Breadcrumbs */}
        <div className="flex items-center space-x-2 text-[12px] text-on-surface-variant mb-12">
          <Link to="/" className="hover:text-primary transition-colors">Home</Link>
          <span>/</span>
          <span className="text-silver-text">Terms of Service</span>
        </div>

        {/* Header */}
        <div className="mb-16">
          <div className="bg-primary/10 text-primary text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded inline-block mb-6 border border-primary/20">
            Legal Agreements
          </div>
          <h1 className="font-display-lg text-[48px] md:text-[64px] font-bold text-silver-text mb-4 leading-tight">
            Terms of <span className="text-primary">Service</span>
          </h1>
          <p className="text-[14px] text-on-surface-variant">
            Last Updated: June 4, 2026
          </p>
        </div>

        {/* Content */}
        <div className="space-y-12 text-[15px] text-on-surface-variant leading-relaxed">
          
          {/* Section 1 */}
          <div>
            <h2 className="text-[20px] font-bold text-silver-text mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing and purchasing from Algo Forex EA (hereinafter referred to as "we", "us", "our", or the "Platform"), you acknowledge that you have read, understood, and agreed to be legally bound by these Terms of Service. If you do not agree to these terms, you must immediately cease using the Platform and any of its digital content.
            </p>
          </div>

          {/* Section 2 */}
          <div>
            <h2 className="text-[20px] font-bold text-silver-text mb-4">2. Digital Products and Licenses</h2>
            <p className="mb-4">
              Algo Forex EA provides digital files including but not limited to compiled MetaTrader 4 (.ex4) and MetaTrader 5 (.ex5) Expert Advisors, templates, indicator configurations, and setup parameters (collectively, "Digital Products").
            </p>
            <ul className="list-disc pl-5 space-y-3">
              <li>All Digital Products sold are provided "as-is", with all account licensing checks, expiration dates, and authorization scripts fully removed for personal retail backup usage.</li>
              <li>A purchase grants you a personal, perpetual, non-exclusive, and non-transferable license to execute the Digital Products on unlimited trading accounts under your control.</li>
              <li>You may not resell, repackage, distribute, or lease any Digital Products obtained from Algo Forex EA to any third parties without prior written consent.</li>
            </ul>
          </div>

          {/* Section 3 */}
          <div>
            <h2 className="text-[20px] font-bold text-silver-text mb-4">3. User Responsibilities</h2>
            <p className="mb-4">
              As a user and trader, you are fully responsible for the configurations and risks associated with live trading terminals:
            </p>
            <ul className="list-disc pl-5 space-y-3">
              <li>You must evaluate all Expert Advisors on demo accounts first before initiating execution on live funds.</li>
              <li>You must configure proper lot sizing, maximum drawdown rules, and safety metrics matching your account capital.</li>
              <li>You agree to monitor your trading platforms, VPS connections, and internet connectivity to prevent software or execution errors.</li>
            </ul>
          </div>

          {/* Section 4 */}
          <div>
            <h2 className="text-[20px] font-bold text-silver-text mb-4">4. Support Policy</h2>
            <p className="mb-4">
              We provide installation and troubleshooting support for all purchased Expert Advisors.
            </p>
            <p>
              Support is limited to file installation, configuration inputs, applying setfiles, and resolving code errors. We do not provide financial advice, broker recommendations, or custom modifications to trading logic. Support channels are available via WhatsApp and Email.
            </p>
          </div>

          {/* Section 5 */}
          <div>
            <h2 className="text-[20px] font-bold text-silver-text mb-4">5. Limitation of Liability & Trading Risks</h2>
            <div className="bg-[#1A1B20] border border-primary/20 rounded-xl p-6 mb-6">
              <div className="text-primary text-[12px] font-bold uppercase tracking-widest mb-3">
                Risk Warning
              </div>
              <p className="text-[14px]">
                Trading financial instruments, forex, contracts for difference (CFDs), and gold involves high risks and can lead to complete loss of capital. Algo Forex EA, its developers, and affiliates shall not be held liable for any financial losses, margin calls, broker slippages, account drawdowns, or damages arising out of your use or inability to use the trading robots.
              </p>
            </div>
            <p>
              Past simulation results and backtest records do not guarantee future performance. Market conditions change dynamically, and algorithmic strategies that historically generated profits may lose money in different market phases.
            </p>
          </div>

          {/* Section 6 */}
          <div>
            <h2 className="text-[20px] font-bold text-silver-text mb-4">6. Intellectual Property</h2>
            <p>
              All branding elements, layout styling, copy, icons, and original assets on the Algo Forex EA website are the intellectual property of Algo Forex EA. Expert Advisors featured on the site are properties of their respective original developers; Algo Forex EA holds no trademark claims over the individual EA names and acts as a retail backup unlock provider.
            </p>
          </div>

          {/* Section 7 */}
          <div>
            <h2 className="text-[20px] font-bold text-silver-text mb-4">7. Termination of Service</h2>
            <p>
              We reserve the right to suspend or terminate your access to product downloads and support channels if we detect violation of our terms, product distribution abuse, fraudulent transactions, or threatening behavior toward our support operators.
            </p>
          </div>

        </div>
      </section>
    </main>
  );
};

export default TermsOfService;
